import axios from "axios";
import config from "../config";

export function getInsights() {
  return axios.get(`${config.api_url}/insights`);
}
